import React from 'react';
import { DiabetesPageTemplate } from './DiabetesPageTemplate';
import { diabetesImages } from './diabetesPageData';

const faqItems = [
  {
    question: 'What are the early warning signs of diabetes?',
    answer:
      'Common early signs include increased thirst, frequent urination, unexplained fatigue, blurred vision, slow-healing wounds and unusual weight changes. Type 2 diabetes can develop gradually, so symptoms may be mild at first.',
  },
  {
    question: 'Can diabetes be controlled with diet and exercise alone?',
    answer:
      'In some people with prediabetes or early Type 2 diabetes, healthy eating, regular exercise and weight management can significantly improve blood sugar control. However, some people still need medicines or insulin depending on their condition.',
  },
  {
    question: 'What is the difference between Type 1 and Type 2 diabetes?',
    answer:
      'Type 1 diabetes happens when the body produces little or no insulin and usually requires lifelong insulin therapy. Type 2 diabetes is more common and often involves insulin resistance, where the body does not use insulin effectively.',
  },
  {
    question: 'Who should get tested for diabetes?',
    answer:
      'People with obesity, a family history of diabetes, high blood pressure, sedentary lifestyle, previous gestational diabetes or symptoms such as excessive thirst and frequent urination should discuss screening with a doctor.',
  },
  {
    question: 'Can diabetes lead to other health problems?',
    answer:
      'Yes. Uncontrolled diabetes can affect the heart, kidneys, nerves, eyes and feet. Long-term high blood sugar can also increase the risk of infections and slow wound healing.',
  },
  {
    question: 'Is gestational diabetes temporary?',
    answer:
      'Gestational diabetes usually develops during pregnancy and often improves after delivery. Even so, it needs proper medical monitoring because it can affect both mother and baby and may increase future diabetes risk.',
  },
];

const DiabetesFAQs = () => {
  return (
    <DiabetesPageTemplate
      eyebrow="Support & Guidance"
      title="Frequently Asked Questions About Diabetes"
      intro="Diabetes symptoms can develop gradually and may be easy to miss, especially in people with Type 2 diabetes. Clear answers help people understand the condition earlier and manage it with less confusion."
      heroSummary="These are some of the most common concerns people have when they first start learning about diabetes."
      heroImage={diabetesImages.photoImg}
      heroAlt="Doctor answering questions about diabetes"
      sections={[
        {
          title: 'Before You Dive In',
          paragraphs: [
            'Only one of three people with diabetes know that they have it, especially because the symptoms develop gradually and are hard to identify at first, typically for a person with Type 2 diabetes.',
            'We will attempt to answer some of the questions and concerns you may have about the disorder so as to help clear and make this disorder simpler to understand and deal with.',
          ],
          image: diabetesImages.checkupImg,
          imageAlt: 'Diabetes consultation and check-up',
          imageCaption: 'Timely questions often lead to timely testing, treatment, and reassurance.',
        },
      ]}
      faqItems={faqItems}
    />
  );
};

export default DiabetesFAQs;
